export const strengthArr = [
  {
    img: "https://file.caretbio.com/caretbio/d3f17881d53c62b768c375f1861a37e0.png",
    desc: ["최소 100장부터 인쇄 가능! 소규모 모임, 굿즈용으로 좋아요"],
  },
  {
    img: "https://file.caretbio.com/caretbio/5883bfada5b43ef3c3c598834078fdb9.png",
    desc: ["최소 비용으로 최대 마케팅 효과를", "볼 수 있습니다"],
  },
  {
    img: "https://file.caretbio.com/caretbio/4625024a198591171f84a2ee33faf84d.png",
    desc: ["인쇄 기간은 일주일!", "빠르게 작업하여 보내드려요"],
  },
];

export const strengthSlideArr = [
  {
    img: "https://file.caretbio.com/caretbio/c9f2c279f7b9fd0d8ba691e98a7ee08a.png",
    title: "넓은 인쇄영역",
    desc: "친환경 소재 봉투에 브랜드 로고를 넣어 브랜드 가치를 올려주세요",
  },
  {
    img: "https://file.caretbio.com/caretbio/488787e1a0ee5fd0d844199b8a156c8f.png",
    title: "유럽산 잉크 사용",
    desc: "인쇄 품질 기준이 엄격한 유럽산 잉크를 사용해요",
  },
  {
    img: "https://file.caretbio.com/caretbio/862aad3dcbdbe75508401667fdfdbcba.png",
    title: "다양한 컬러와 사이즈",
    desc: "인디핑크, 네온, 블랙, 크림, 반투명속비닐까지 용도와 분위기에 맞게 선택할 수 있어요",
  },
  {
    img: "https://file.caretbio.com/caretbio/621486502fe74265b2490993660a13dd.png",
    title: "친환경 소재",
    desc: "친환경 재생 택배봉투(EL606)와 바이오매스 택배봉투(EL727)에 소중한 제품을 담아 보세요",
  },
];

export const SizeData = {
  EL606택배봉투_인디핑크: [
    {
      title: "소 size",
      size: "250mm x 350mm + 40mm",
      desc: "얇은 의류, 속옷, 모자를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL606_인디핑크_소.jpg", desc: "" },
      ],
    },
    {
      title: "중 size",
      size: "320mm x 400mm + 40mm",
      desc: "셔츠, 니트, 바지를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL606_인디핑크_중.jpg", desc: "" },
      ],
    },
    {
      title: "대 size",
      size: "380mm x 470mm + 40mm",
      desc: "후드티, 도톰한 의류를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL606_인디핑크_대.jpg", desc: "" },
      ],
    },
  ],
  EL606택배봉투_네온: [
    {
      title: "특대 1호 size",
      size: "450mm x 580mm + 40mm",
      desc: "아우터 두꺼운 후드티를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL606_네온_특대1.jpg", desc: "" },
      ],
    },
    {
      title: "특대 2호 size",
      size: "550mm x 800mm + 40mm",
      desc: "겨울용 아우터를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL606_네온_특대2.jpg", desc: "" },
      ],
    },
    {
      title: "특대 3호 size",
      size: "700mm x 830mm + 40mm",
      desc: "이불 패드를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL606_네온_특대3.jpg", desc: "" },
      ],
    },
  ],
  EL727택배봉투_블랙: [
    {
      title: "중 size",
      size: "320mm x 400mm + 40mm",
      desc: "셔츠, 니트, 바지를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_블랙_중.jpg", desc: "" },
      ],
    },
    {
      title: "대 size",
      size: "380mm x 470mm + 40mm",
      desc: "후드티, 도톰한 의류를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_블랙_대.jpg", desc: "" },
      ],
    },
  ],
  EL727택배봉투_아이보리: [
    {
      title: "소 size",
      size: "250mm x 350mm + 40mm",
      desc: "얇은 의류, 속옷, 모자를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_크림_소.jpg", desc: "" },
      ],
    },
    {
      title: "중 size",
      size: "320mm x 400mm + 40mm",
      desc: "셔츠, 니트, 바지를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_크림_중.jpg", desc: "" },
      ],
    },
    {
      title: "대 size",
      size: "380mm x 470mm + 40mm",
      desc: "후드티, 도톰한 의류를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_크림_대.jpg", desc: "" },
      ],
    },
    {
      title: "특대 size",
      size: "450mm x 580mm + 40mm",
      desc: "아우터 두꺼운 후드티를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_크림_특대.jpg", desc: "" },
      ],
    },
  ],
  EL727속비닐봉투_반투명: [
    {
      title: "미니 size",
      size: "110mm x 170mm + 40mm",
      desc: "카드 악세사리 사진을 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_반투명_미니.jpg", desc: "" },
      ],
    },
    {
      title: "특소 size",
      size: "170mm x 250mm + 40mm",
      desc: "수첩 핸드폰케이스를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_반투명_특소.jpg", desc: "" },
      ],
    },
    {
      title: "소 size",
      size: "250mm x 350mm + 40mm",
      desc: "얇은 의류, 속옷, 모자를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_반투명_소.jpg", desc: "" },
      ],
    },
    {
      title: "중 size",
      size: "320mm x 400mm + 40mm",
      desc: "셔츠, 니트, 바지를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_반투명_중.jpg", desc: "" },
      ],
    },
    {
      title: "대 size",
      size: "380mm x 470mm + 40mm",
      desc: "후드티, 도톰한 의류를 포장하기 적합한 사이즈 입니다.",
      imgs: [
        { url: "/assets/imgs/print/info_size/EL727_반투명_대.jpg", desc: "" },
      ],
    },
  ],
};
